import { CountryCode } from '@qred/shared-enums';

type CountryCodeRegex = {
  [key in CountryCode]: RegExp;
};

// Keep these regexes in sync with svc-user-management and svc-qosmos-client
// to prevent application rejection
export const personalNumberRegex: CountryCodeRegex = {
  BE: /\d{2}\.\d{2}\.\d{2}-\d{3}\.\d{2}/, // DD.MM.YY-XXX.CC
  SE: /^(19|20)\d{10}$/, // YYYYMMDDXXXX (12 digits)
  NO: /^\d{11}$/, // 11 digits
  DK: /^\d{6}-\d{4}$/, // DDMMYY-XXXX
  FI: /^\d{6}[-A]\d{3}[0-9A-Y]$/, // DDMMYY[-A]XXXC
  NL: /.*/, // Match anything for Netherlands as personal number is not used.
  DE: /.*/, // Match anything for Germany until requirements are clear.
};

// Keep these regexes in sync with svc-user-management and svc-qosmos-client
// to prevent application rejection
export const companyNumberRegex: CountryCodeRegex = {
  BE: /^[0]?[0-9]{10}$/, // 10 digits (optional leading 0)
  SE: /^[0-9]{10}$/, // 10 digits
  NO: /^[0-9]{9}$/, // 9 digits
  DK: /^[0-9]{8}$/, // 8 digits
  FI: /^[0-9]{7}-[0-9]$/, // XXXXXXX-X
  NL: /^[0-9]{8}$/, // 8 digits
  DE: /^(HRA|HRB|VR) (\d{3,6})( [A-Z]{1,2})?$|^\d{10,12}$/, // HRA/HRB/VR XXXXXX [XX] or 10-12 digits
};

// Additional frontend input variations that can be normalized to the backend format.
// Markets with no additional variations use /$^/ (never matches).
export const additionalPersonalNumberRegex: CountryCodeRegex = {
  BE: /^\d{11}$/, // DDMMYYXXXCC (11 digits)
  SE: /^(19|20)\d{6}-\d{4}$/, // YYYYMMDD-XXXX (with hyphen)
  DK: /^\d{10}$/, // DDMMYYXXXX (10 digits)
  FI: /^\d{6}[-Aa]\d{3}[0-9A-Ya-y]$/, // DDMMYY[-Aa]XXXc (with lowercase letters)
  NO: /$^/, // No additional variations
  NL: /$^/, // No additional variations
  DE: /$^/, // No additional variations
};
